import React from 'react';

import { Category } from '../model/hgf';

// Renders a group of tracks as a grid of cumulative level checkboxes, aligning
// the level boxes across tracks into shared rows. Shared between the legacy
// HGF1 page and the new HGF2 page so both look identical.
export function HGFCategory({
  category,
  levels,
  onChange,
}: {
  category: Category;
  levels: Record<number, number>;
  onChange: (track: number, level: number) => void;
}): JSX.Element {
  const gridStyle = {
    '--hgf-columns': category.tracks.length,
    '--hgf-rows':
      1 + Math.max(...category.tracks.map((track) => track.levels.length)),
  } as React.CSSProperties;
  return (
    <div className="hgf" style={gridStyle}>
      <div className="hgf__category">
        {category.tracks.map((track, trackIndex) => (
          <div key={track.id} className="hgf__track">
            <div className="hgf__trackname">{track.name}</div>
            {track.levels.map((level, levelIndex) => (
              <React.Fragment key={level.level}>
                <input
                  id={`hgf-${category.id}-${track.id}-${level.level}`}
                  type="checkbox"
                  checked={levels[trackIndex] > levelIndex}
                  onChange={(event) =>
                    event.target.checked
                      ? onChange(trackIndex, levelIndex + 1)
                      : onChange(trackIndex, levelIndex)
                  }
                />

                <label
                  className="hgf__level"
                  htmlFor={`hgf-${category.id}-${track.id}-${level.level}`}
                >
                  <div className="hgf__levelname">{level.level}</div>
                  <div className="hgf__examples">
                    {level.examples.map((example) => (
                      <div key={example}>{example}</div>
                    ))}
                  </div>
                </label>
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
